<template>
  <div class="animated fadeIn">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm" style="margin-top: -1em;">
          <RankingTable 
            :isCluster="isCluster" 
            :thresholds="thresholds" 
            :percentageNumberOfDecimalPoints="percentageNumberOfDecimalPoints" 
            :filtervalues="filtervalues"
            :selection="selection"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RankingTable from './RankingTable';

  export default {
    name: 'DashboardPanelRanking',

    components:{
      RankingTable
    },

    props: {
      rankingdata: { type: Object, default: null },
      isCluster: {default: true},
      thresholds: null,
      percentageNumberOfDecimalPoints: {type: Number, default: 2},
      filtervalues: null,
      selection: null
    },
  }

</script>

<style>

</style>

<style scoped>

.row {
  padding: 0px;
}

.col-sm {
  padding-top: 1rem;
}

h3{
  height: 36pt;
  line-height: 28pt;
  text-align: center;
  color: #111111;
  font-size: 16pt;
  font-stretch: extra-condensed;
}

div.leftImage {
  position: absolute;
  left: 3px;
  top: 0px;
  bottom: 1px;
}

.pagbox {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: flex-start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;

  width: 100%;
}

.pagheader {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;

  width: 100%;
}

.pagbox>* {
  flex: 1 1 300px;
  -ms-flex: 0 0 300px;
  /* margin:1px;
  margin: .25em; */
}

.pagheader>* {
  flex: 1 1 150px;
  -ms-flex: 0 0 150px;
  margin:1px;
  /* margin: .5em; */
}

.pagitem{
  min-width: 800px;
  /* max-width: 1200px; */
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagshopsitem{
  min-width: 150px;
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagborder {
  background-color: rgba(255, 255, 255, 0.596);

  margin:0.25em;
  border-style: solid;
  border-width: 1px;
  border-color: #BFBFBF;
  border-radius: 4px;
}

</style>
